import { useEffect, useState } from "react";

interface Props {
  value: string;
  duration?: number;
  fontSize: number;
}

const SCRAMBLE = "0123456789ABCDEF#@$%&*";

export function GlitchNumber({ value, duration = 900, fontSize }: Props) {
  const [display, setDisplay] = useState(value);

  useEffect(() => {
    let raf = 0;
    const start = performance.now();
    const target = value;
    const len = target.length;

    const step = (now: number) => {
      const t = Math.min(1, (now - start) / duration);
      let out = "";
      for (let i = 0; i < len; i++) {
        const reveal = i / len;
        if (t > reveal + 0.05) {
          out += target[i];
        } else if (target[i].match(/[\s.,\u00a0]/)) {
          out += target[i];
        } else {
          out += SCRAMBLE[Math.floor(Math.random() * SCRAMBLE.length)];
        }
      }
      setDisplay(out);
      if (t < 1) raf = requestAnimationFrame(step);
      else setDisplay(target);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value, duration]);

  return (
    <span className="mission-n glitch-n" style={{ fontSize }}>
      {display}
    </span>
  );
}
